export default __webpack_public_path__ + "static/media/icon-big-gestioneutenti-88-px.ab54a54f.svg";